let arr=[
    {name:'性质一',value:'性质一'},
    {name:'性质二',value:'性质二'}
]
export default arr